import React, { useState, useEffect } from "react";
import { useStateValue } from "../../StateProvider";
import { getCartTotal } from "../../reducer";
import { PaystackButton } from "react-paystack";
import publicKey from "../../pkk";
import "./CheckoutTotal.css";
import ReviewCart from "./ReviewCart";
import { Lock } from "lucide-react";

function CheckoutTotal({ user, onPaymentSuccess, email, name, amount, phone, isFormValid, subaccountCode }) {
  const [{ cart }] = useStateValue();
  const [orderTotal, setOrderTotal] = useState(0);
  const [showCart, setShowCart] = useState(false);

  useEffect(() => {
    const total = getCartTotal(cart);
    const tax = total * 0.075;
    setOrderTotal((total + tax).toFixed(2));
  }, [cart]);

  const fmt = (n) =>
    new Intl.NumberFormat("en-NG", { style: "currency", currency: "NGN", minimumFractionDigits: 2 }).format(n);

  const subtotal = getCartTotal(cart);
  const tax = subtotal * 0.075;

  const componentProps = {
    email,
    amount: amount * 100,
    metadata: { name, phone },
    publicKey,
    text: "Pay Now",
    onSuccess: (res) => onPaymentSuccess(res.reference),
    onClose: () => {},
    ...(subaccountCode && { subaccount: subaccountCode, bearer: "subaccount" }),
  };

  return (
    <div className="cot">
      <div className="cot__header">
        <h5 className="cot__title">Order Summary</h5>
        <button className="cot__toggle" onClick={() => setShowCart((s) => !s)}>
          {showCart ? "Hide" : "Show"} items
        </button>
      </div>

      {showCart && <div className="cot__items"><ReviewCart /></div>}

      <div className="cot__rows">
        <div className="cot__row">
          <span>Subtotal</span>
          <span>{fmt(subtotal)}</span>
        </div>
        <div className="cot__row">
          <span>Shipping</span>
          <span className="cot__muted">Awaiting Rider</span>
        </div>
        <div className="cot__row">
          <span>Estimated Tax (7.5%)</span>
          <span>{fmt(tax)}</span>
        </div>
        <div className="cot__total">
          <span>Total</span>
          <strong>{fmt(Number(orderTotal))}</strong>
        </div>
      </div>

      {isFormValid && isFormValid() ? (
        <PaystackButton className="cot__pay-btn" {...componentProps} />
      ) : (
        <button className="cot__pay-btn cot__pay-btn--disabled">Pay Now</button>
      )}
      <p className="cot__secure"><Lock size={12} /> Payments secured by Paystack</p>
    </div>
  );
}

export default CheckoutTotal;
